module.exports = __webpack_public_path__ + "static/media/deskDraft1.ff8f4845.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/deskDraft1.jpg
// module id = 160
// module chunks = 0